import { render, staticRenderFns } from "./AccessDeniedError.vue?vue&type=template&id=2856dd34&scoped=true&"
import script from "./AccessDeniedError.vue?vue&type=script&lang=js&"
export * from "./AccessDeniedError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856dd34",
  null
  
)

export default component.exports